<template>
  <section class="content">
    <admin-header
      :title="'Calculations'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminCalculation',
    data () {
      return {
        newEntityScreen: 'Admin - Calculations',
        searchEntityScreen: 'Admin - Calculation search',
        filterEventName: 'admin-calculation-filter',
        filterName: 'CalculationFilter',
        entityName: 'calculation'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminCalculation.vue?44174e7b